import { render, staticRenderFns } from "./SignupLinkCurrent.vue?vue&type=template&id=31e82bef&scoped=true"
import script from "./SignupLinkCurrent.vue?vue&type=script&lang=js"
export * from "./SignupLinkCurrent.vue?vue&type=script&lang=js"
import style0 from "./SignupLinkCurrent.vue?vue&type=style&index=0&id=31e82bef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e82bef",
  null
  
)

export default component.exports